import React, { ChangeEvent } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { WithTranslation, withTranslation } from 'react-i18next';

interface AddBrokerRateCommentProps extends WithTranslation {
  toggle: () => void;
  isOpen: boolean;
  onClose: () => void;
  onSend: () => void;
  patchValue: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

class AddBrokerRateCommentModal extends React.PureComponent<AddBrokerRateCommentProps> {

  render() {
    const { t } = this.props;

    return (
      <Modal style={{ minWidth: '500px' }} isOpen={this.props.isOpen} toggle={this.props.toggle} autoFocus={false}>
        <ModalHeader toggle={this.props.toggle}>{t('l.broker_rate.add_comment')}</ModalHeader>
        <div>
          <ModalBody>
            <textarea
              rows={6}
              cols={50}
              className="form-input form-control"
              onChange={(event) => this.props.patchValue(event)}
            ></textarea>
          </ModalBody>
        </div>
        <ModalFooter>
          <button className="btn btn-outline-secondary mr-1" onClick={this.props.onClose}>{t('b.broker_rate.refuse_comment').toUpperCase()}</button>
          <button className="btn btn-primary" onClick={this.props.onSend}>{t('b.broker_rate.add_comment').toUpperCase()}</button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(AddBrokerRateCommentModal);
